import type { PropsWithChildren } from 'react'

export const ProvisionerLayout = ({ children }: PropsWithChildren) => {
  return <div>{children}</div>
}

export const ProvisionerContents = ({ children }: PropsWithChildren) => {
  return <div className="mx-auto max-w-7xl p-4">{children}</div>
}
